import api from './api';

const breedService = {
  getAllBreeds: async () => {
    const response = await api.get('/api/breeds');
    return response.data;
  },
  createBreed: async (name) => {
    const response = await api.post('/api/breeds', { name });
    return response.data;
  },
  deleteBreed: async (id) => {
    const response = await api.delete(`/api/breeds/${id}`);
    return response.data;
  },
};

export default breedService;